import React, { useEffect } from "react";
import BlocksV2 from "./common/blocksV2";
import FourOFour from "./global/404";
import Loader from "./common/loader";
import Meta from "./global/meta";
import { useQuery } from "@apollo/client";
import { GET_ARTICLE } from "../graphql/queries";
import { Store } from "../contexts/Store";

export default function Landing () {
  const { loading, data } = useQuery(GET_ARTICLE, { variables: { homepage: true } });
  const article = data && data.article;

  useEffect(() => {
    if (article) Store.update(s => { s.globalClass = `landing page ${article.handle}`; });
  }, [article]);

  if (article === undefined || loading) return <Loader withMargins />;
  if (article === null) return <FourOFour />;

  return (
    <div id="landing">
      <Meta />
      <div id="content">
        {article.content.rows ? <BlocksV2 rows={article.content.rows} /> : null}
      </div>
    </div>
  );
}
